<template>
  <div
    v-observe-visibility="{
      callback: backToTopVisibilityChanged,
      throttle: 350,
      throttleOptions: {},
    }"
    class="back-to-top-container"
    :class="{ show: showBackToTopButton }"
  >
    <div class="back-to-top">
      <button
        v-scrollto="{
          target: '[data-back-to-top]',
          options: { duration: 200, offset: 0 },
        }"
        :aria-label="$t('Back to top')"
        @click.prevent.stop
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="up">
          <path
            fill="currentColor"
            fill-rule="nonzero"
            d="M32.039 20L12 41.91l2.246 2.055L32.039 24.51l17.714 19.376 2.246-2.053v-.002z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteDetailBackToTopContainer extends Vue {
  showBackToTopButton = false
  backToTopVisibilityChanged(isVisible: boolean) {
    if (this.$.isUnmounted) return
    this.showBackToTopButton = !isVisible
  }
}

export default toNative(CampsiteDetailBackToTopContainer)
</script>

<style scoped>
.back-to-top-container {
  position: absolute;
  top: 0;
  right: 0;
  height: 200vh;
  z-index: 10;
}

.back-to-top {
  bottom: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  /* transform: translateY(2em); */
  transition: all 0.3s ease-in-out;
  visibility: hidden;
  will-change: opacity;
  opacity: 0;
  transform: translateX(100%);
}

.show .back-to-top {
  opacity: 1;
  visibility: visible;
  transform: translateX(0);
}

.back-to-top button {
  align-items: center;
  background-color: rgba(39, 73, 109, 0.66);
  border-radius: 1.2em 0 0 1.2em;
  border: none;
  box-shadow: none;
  display: flex;
  height: 2.6em;
  justify-content: center;
  padding: 0;
  width: 3em;
}

.back-to-top button:active {
  background-color: rgba(39, 73, 109, 1);
  transform: translateY(0);
}

.back-to-top .up {
  width: 2em;
}

.back-to-top .up path {
  stroke: #fff;
  fill: #fff;
}

@media (hover: hover) {
  .back-to-top button:hover,
  .back-to-top button:focus-visible {
    background-color: rgba(39, 73, 109, 1);
  }
}
</style>
